import React, { useState, useRef } from "react";
import MUIDataTable from "mui-datatables";
import { useEffect } from "react";
import {
  Row,
  Card,
  Col,
  Dropdown,
  Button,
  Modal,
  Container,
} from "react-bootstrap";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  accountApi,
  addUser,
  deleteUser,
  listRole_twoApi,
  getMarket,
  editcapex,
  tmoDallas,
  CAPEXReport,
  crewCompanyApi,
  listUserApi_two,
  vendorApi,
  addAcccount,
  listOneUser,
  updateUser,
  CsvUpload,
  tierapi,
  viewmpimpo,
  mpimpo,
  managEngineer,
} from "../../../common/config";
import {
  AccountReducerAction,
  OneUserReducerAction,
  addUserAction,
  deleteAcccountReducerAction,
  GetMarketReducerAction,
  getCrewCompanyAction,
  updateAcccountReducerAction,
  RoleReducerAction,
  UserListReducerAction,
  TierListReducerAction,
  OneTierReducerAction,
  popUpUpdate,
  GetOneUserAction,
} from "../../../store/actions/createTicketManageFields";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { black } from "material-ui/styles/colors";
import {
  google_map_api,
  center,
  dbdatetodate,
  customDataTableOptionObject,
  advancdExportOnecustomDataTableOptionObject,
  getMuiThemeCommon,
  wrapText,
} from "../../../common/variables";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import { PDFUploadActionreturn } from "../../../store/actions/dashboardActions";
import CommonBulkUploader from "../Custom/CommonBulkUploader";
import Add from "../../../icons/Svg/Add";

import parse from "html-react-parser";
import CommonModal from "../Custom/CommonModal";

const moment = require("moment");
const CapexReport = () => {
  let pStatusArry = [];
  let vStatusArry = [];
  let mStatusArry = [];
  let newmStatusArry = [
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "C", value: "C" },
    { label: "D", value: "D" },
    { label: "E", value: "E" },
    { label: "F", value: "F" },
    { label: "G", value: "G" },
  ];

  let caseStatusarry = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
  ];

  let multipleTechno = [];

  let cStatusArry = [];
  // let editTrue=0
  const options = {
    download: "false",
    filterType: "none",
    selectableRows: false,
    responsive: true,
  };

  let accountArry = [];
  let tierArry = [];

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});
  const [show, setShow] = useState(false);
  const [closer, setCloser] = useState(false);
  const [siteFile, uploadedFile] = useState([]);
  const [fileshow, setfileShow] = useState(false);
  let [sImpact, setSectorImpact] = useState([]);
  let [marketts, setMarkets] = useState([]);
  const [date, dfefdewdewdate] = useState("");
  // const [date, setDate] = useState(null);
  const [reassigned_date, dfedate] = useState();
  const [alersdadsa, setalersdadsa] = useState();
  let [marketthswss, setmarketts] = useState([]);
  const [edit, setedit] = useState();

  // const [subtractedDays, setSubtractedDays] = useState(null);

  let [Case, setCase] = useState([]);
  // let [tech_affected, setTech] = useState([]);

  const submitHandler = async (e) => {
    e.preventDefault();
    console.log("form==", "form");
    let newform = new FormData();
    newform.append("uploadFile", siteFile);
    newform.append("uploadfor", "Crew");
    console.log("form==", newform);
    console.log(
      "resp",
      dispatch(PDFUploadActionreturn(CsvUpload, newform, "usercrew"))
    );
    setShow(false);
  };

  const uploadCsvFile = (e) => {
    console.log(e.target.files, "files");
    uploadedFile(e.target.files[0]);
  };

  const handleClose = () => {
    reset({});
    setShow(false);
  };
  const handleShow = () => {
    reset({});
    setShow(true);
  };

  const filehandleClose = () => {
    reset({});
    setfileShow(false);
  };
  const filehandleShow = () => {
    reset({});
    setfileShow(true);
  };

  const handlesetSectorImpect = (e) => {
    setSectorImpact(e);
    // setDepartmentError(false)
    console.log(sImpact, "sImpact");
  };
  const handleCase = (e) => {
    setCase(e);
    console.log(Case, "new add");
  };
  const handleMarket = (e) => {
    setMarkets(e);
    setMarketError(false);
    console.log(marketts, "marketts");
  };

  let sectorsImpacted = [
    // {
    //   value: "MPAG",
    //   label: "MPAG"
    // },
    // {
    //   value: "MOP",
    //   label: "MOP"
    // },
    {
      value: "RAN SUPPORT",
      label: "RAN SUPPORT",
    },
    // {
    //   value: "IX SUPPORT",
    //   label: "IX SUPPORT"
    // },
    {
      value: "TROUBLE TICKET",
      label: "TROUBLE TICKET",
    },
    {
      value: "E911 CALL TEST",
      label: "E911 CALL TEST",
    },
    {
      value: "FOURTY EIGHT",
      label: "FOURTY EIGHT",
    },
    {
      value: "POST IX RF SUPPORT",
      label: "POST IX RF SUPPORT",
    },
    {
      value: "CIQ SCRIPTING",
      label: "CIQ SCRIPTING",
    },
    {
      value: "NETWORK DATABASE",
      label: "NETWORK DATABASE",
    },
    {
      value: "T MOBILE DASHBOARD",
      label: "T MOBILE DASHBOARD",
    },
    {
      value: "MPAG",
      label: "MPAG",
    },
    {
      value: "TRAINING",
      label: "TRAINING",
    },
    {
      value: "ADMIN",
      label: "ADMIN",
    },
  ];
  // const uploadCsvFile = (e) => {
  //   let files=[]

  //   console.log(e.target.files[0],"ON_CHANGE_FILES:", e.target.files.length);

  //   for(let i=0;i<e.target.files.length;i++){
  //     files.push(e.target.files[i])
  //   }
  //   console.log(...files)
  //   uploadedFile(files)

  // };

  const [modalCentered, setModalCentered] = useState(false);
  const [newAccount, setAccount] = useState({});
  const [editTrue, seteditTrue] = useState(0);
  const [ven, setVen] = useState("");
  const [departmentError, setDepartmentError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  const [updateTrue, setupdateTrue] = useState(0);
  const [formtype, addformtype] = useState("");

  const [commonModalState, setcommonModalState] = useState(false);
  const [commonModalSize, setcommonModalSize] = useState(false);
  const [commonModalBody, setcommonModalBody] = useState("");
  const [commonModalTitle, setcommonModalTitle] = useState("");
  const [commonModalHeader, setcommonModalHeader] = useState("");

  let [tech_affected, setTech] = useState([]);

  const [commonModalBodyFilter, setcommonModalBodyFilter] = useState("");
  const [commonModalStateFilter, setcommonModalStateFilter] = useState(false);
  const [commonModalHeaderFilter, setcommonModalHeaderFilter] = useState("");
  const [commonModalSizeFilter, setcommonModalSizeFilter] = useState(false);
  const [commonModalTitleFilter, setcommonModalTitleFilter] = useState("");
  const newCommentRef = useRef({});
  const oldCommentRef = useRef({});

  const myRef = useRef(null);
  myRef.current = (
    <form className="myFormClass">
      <div className="row" style={{ padding: "5px" }}>
        <input
          id="comment-edited"
          style={{ marginBottom: "3px" }}
          type="text"
        />
      </div>
      <div className="row" style={{ marginBottom: "3px", padding: "5px" }}>
        <button
          type="submit"
          onClick={(e) => {
            e.preventDefault();

            const commentInput = document.querySelector("#comment-edited");
            if (commentInput) {
              // new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })).getTime()
              const { rolename, uniqueid, name } = JSON.parse(
                localStorage.getItem("userDetails")
              );

              newCommentRef.current = {
                name: name,
                created_date: "",
                userId: uniqueid,
                role: rolename,
                text: commentInput?.value,
              };

              //   console.log("commentInput => ", commentInput, commentInput?.value);
              setValue("notes", `${commentInput?.value},${getValues("notes")}`);
            }
            setcommonModalStateFilter(false);
          }}
          className="btn btn-primary"
          style={{ marginBottom: "3px" }}
        >
          Submit
        </button>
      </div>
    </form>
  );

  const [showPopup, setShowPopup] = useState(false);
  const [noteValue, setNoteValue] = useState("");

  const handleAddClick = () => {
    // setShowPopup(true);
    //   const [commonModalStateFilter, setcommonModalStateFilter] = useState(false);

    setcommonModalStateFilter(true);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  const handleNoteChange = (event) => {
    setNoteValue(event.target.value);
  };

  const handleAddNote = () => {
    console.log("Added note:", noteValue);
    setShowPopup(false);
  };

  let optionss = useSelector((state) => {
    let technology = state.OneCommonResponse.technologyName;
    //let technologies=state.OneCommonResponse.technologyName
    console.log(technology, "technologies");
    // let technologiesname=technology?.map((items)=>
    // {
    //     console.log(items,'ujujujujuju')
    //     return{
    //         label:items?.technologyName,
    //         value:items?.technologyName,
    //         uniqueid:items?._id,
    //     }
    // })

    if (technology?.length > 0) {
      multipleTechno = [];
      if (technology.length > 0) {
        console.log("comeToStart");
        // setmultiTechnology([])
        console.log(technology, "technology");
        multipleTechno = technology.map((ids) => {
          // console.log("the ids -=", ids)
          // let pId = {
          //   label: ids.label,
          //   value: ids.label,
          //   disabled: true
          // }
          // multipleTechno.push(pId)
          // let tmpArry = []
          // tmpArry = technology.map((item) => {
          return {
            value: ids.technologyName,
            label: ids.technologyName,
            id: ids._id,
          };
          // });

          // multipleTechno.push(...tmpArry)
          // setmultiTechnology(multiTechnologylcl)
        });
        console.log(multipleTechno, "multiTechnologymultiTechnology");

        // settechsetter(false)
      }
      // }
    }

    return { multipleTechno };
  });

  let optionsss = useSelector((state) => {
    let technology = state.CommonResponse.technology;
    let sites_Id = state?.OneCommonResponse?.site_id;
    let site_idss = sites_Id?.map((p) => {
      console.log(p.site_id, "hushuhushus");
      return <option>{p?.site_id}</option>;
    });

    return { site_idss };
  });

  const accountss = useSelector((state) => state.OneCommonResponse.accounts);

  const marketnames = useSelector(
    (state) => state.OneCommonResponse.marketName
  );

  const engineers = useSelector((state) => state.OneCommonResponse.engineers);

  const techname = useSelector(
    (state) => state.OneCommonResponse.technologyName
  );

  // const gc = useSelector(state => state.OneCommonResponse.gc_name)
  const gc = useSelector((state) => state.OneCommonResponse.gc_company);

  const siteid = useSelector((state) => state.OneCommonResponse.site_id);

  let oneaccount = {};

  // setAccount(oneaccount)
  //  console.log(oneaccount,"oneaccount")
  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              backgroundColor: "transparent",
              color: black,
            },
          },
        },
      },
    });

  console.log();
  const updateHandler = (e) => {
    console.log("button update clicked", e);

    // dispatch(addUserAction(viewmpimpo, e))
    dispatch(addUserAction(addAcccount, e));
  };
  const deleteHandler = (e) => {
    console.log("button delete clicked", e);

    dispatch(deleteAcccountReducerAction(editcapex, e, "tier"));
    setCloser(true);
  };

  const editpopupHandler = (e) => {
    oldCommentRef.current = e;
    dispatch(GetOneUserAction([]));
    seteditTrue(1);
    setedit(e.uniqueid);
    reset({});
    console.log("button editpopupHandler clicked", e);
    setValue("uniqueid", e.uniqueid, { shouldTouch: true });
    dispatch(OneTierReducerAction(CAPEXReport + "/" + e.uniqueid));
    console.log("gjgjjkbkj", e);
  };

  const CommonModalFun = (body, title, header, type = "md") => {
    setcommonModalState(true);
    setcommonModalSize(type);
    setcommonModalTitle(title);
    setcommonModalBody(body);
    setcommonModalHeader(header);
  };

  const seteditdataHandler = (e) => {
    reset({});
    setupdateTrue(1);
    console.log("e.datee.datee.date", e);
    // let date = e.date?.split("/").reverse().join("/");
    // console.log("hjgsadadda", date);

    const parsedDate = moment(e.date, "DD/MM/YYYY HH:mm:ss").toDate();
    console.log(parsedDate, "parsedDateparsedDate");
    // if (!isNaN(parsedDate)) {
    //   dfefdewdewdate(parsedDate);
    // } else {
    //   console.log("Invalid Date");
    // }
    dfefdewdewdate(parsedDate);

    // let reassigned_date = e.reassigned_date?.split("/").reverse().join("/");
    // console.log("hjgsadadda", reassigned_date);

    // const parsedDate1 =moment(e.reassigned_date).format('DD/MM/YYYY HH:mm:ss');
    if (e.reassigned_date) {
      const parsedDate1 = moment(
        e.reassigned_date,
        "DD/MM/YYYY HH:mm:ss"
      ).toDate();

      console.log(!isNaN(parsedDate1), "parsedDate1parsedDate1");

      dfedate(parsedDate1);
    }

    // if (!isNaN(parsedDate1)) {
    // } else {
    //   console.log("Invalid Date");
    // }

    setValue("inc_ticket", e.inc_ticket, { shouldTouch: true });
    setValue("status", e.status, { shouldTouch: true });
    setValue("site_id", e.site_id, { shouldTouch: true });
    setValue("xPEX", e.xPEX, { shouldTouch: true });
    setValue("gc", e.gc, { shouldTouch: true });
    setValue("tech_affected", e.tech_affected, { shouldTouch: true });
    setValue("sector", e.sector, { shouldTouch: true });
    setValue("category", e.category, { shouldTouch: true });
    setValue("mcps_engineer", e.mcps_engineer, { shouldTouch: true });
    setValue("work_log", e.work_log, { shouldTouch: true });

    setValue("Case", e.Case, { shouldTouch: true });

    setValue("assigned_group", e.assigned_group, { shouldTouch: true });
    setValue("inc_assigned", e.inc_assigned, { shouldTouch: true });
    // setValue("date", e.date, { shouldTouch: true });
    // setValue("reassigned_date", e.reassigned_date, { shouldTouch: true });
    setValue("pier", e.pier, { shouldTouch: true });
    setValue("resolution", e.resolution, { shouldTouch: true });
    setValue("market_name", e.market_name, { shouldTouch: true });
    setValue("account_name", e.account_name, { shouldTouch: true });
    setValue("assignee", e.assignee, { shouldTouch: true });
    setValue("go_back_date", e.go_back_date, { shouldTouch: true });
    setValue("issue_owner", e.issue_owner, { shouldTouch: true });
    setValue("company_name", e.company_name, { shouldTouch: true });
    setValue(
      "notes",
      Array.isArray(e?.notes)
        ? e?.notes
            ?.map(
              (item) => item?.created_date + "-" + item?.name + "-" + item?.text
            )
            ?.join("\n")
        : "",
      { shouldTouch: true }
    );
    // setValue("updatednotes", Array.isArray(e?.updatednotes) ? e?.updatednotes?.map(e => `${e?.created_date} - ${e?.name} - ${e?.text}`).join("\n"):"",{ shouldTouch: true });
    setValue("uniqueid", e.uniqueid, { shouldTouch: true });
    setValue("aging", e.aging, { shouldTouch: true });

    let arr = [];
    arr = e?.sector?.split(",").map((item) => {
      return {
        value: item,
        label: item,
      };
    });
    setSectorImpact(arr);

    let arr1 = [];
    arr1 = e?.Case?.split(",").map((item) => {
      console.log("cases item", item);
      return {
        value: item,
        label: item,
      };
    });
    setCase(arr1);

    let arr12 = [];
    arr12 = e?.tech_affected?.split(",").map((item) => {
      return {
        value: item,
        label: item,
      };
    });

    setTech(arr12);

    let arrm = [];
    arrm = e?.markets?.values?.map((item) => {
      return {
        value: item,
        label: item,
      };
    });

    setMarkets(arrm);
  };

  const onSubmit = async (data) => {
    console.log(
      "current_comment",
      newCommentRef.current,
      oldCommentRef.current
    );
    console.log(data, "dhakjggggg");
    let sector = sImpact?.map((item) => {
      return item?.value;
    });
    let cases = Case?.map((item) => {
      console.log(item?.value, "jsadkad");
      return item?.value;
    });
    let techs = tech_affected?.map((item) => {
      return item?.value;
    });
    const data1 = {
      ...data,
      sector: sector?.join(","),
      Case: cases?.join(","),
      tech_affected: techs?.join(","),
    };
    data1.uniqueid = edit;
    console.log(data1, " datagyyutyyut");

    const newData = new FormData();
    Object.keys(data1).map((i) => {
      console.log("dwdwendwkjndwnf", i);
      newData.append(i, data1[i]);
    });

    // const currentDate = moment();

    // const differenceInDays = moment(date).diff(currentDate, 'days');

    // setSubtractedDays(differenceInDays);

    // data1["reassigned_date"] = moment(reassigned_date).format("DD/MM/yyyy HH:mm:ss")

    if (date != null) {
      data1["date"] = moment(date).format("DD/MM/yyyy HH:mm:ss");
    }

    if (reassigned_date != null) {
      data1["reassigned_date"] = moment(reassigned_date).format(
        "DD/MM/yyyy HH:mm:ss"
      );
    }

    console.log("updateAcccountReducerAction", data1.uniqueid);

    if (data1.uniqueid != undefined) {
      data1["notes"] = [
        newCommentRef.current,
        ...(Array.isArray(oldCommentRef.current?.notes)
          ? oldCommentRef.current?.notes
          : []),
      ];
      dispatch(
        updateAcccountReducerAction(
          editcapex,
          data1.uniqueid,
          data1,
          "department"
        )
      );
      oldCommentRef.current = {};
      newCommentRef.current = {};

      console.log("updateAcccountReducerAction1", data1.uniqueid);

      setCloser(true);
    } else {
      dispatch(addUserAction(editcapex, data1, "department"));
      setCloser(true);
    }
  };

  const dispatch = useDispatch();

  // let datava =useSelector((state)=>{

  // });

  let data = useSelector((state) => {
    console.log("dfwef=", state.OneCommonResponse.listuser);
    let onelistuser = state.OneCommonResponse.listuser;

    // console.log(onelistuser.length, editTrue, "onelistuser")
    if (onelistuser.length > 0 && editTrue == 1) {
      oneaccount = onelistuser?.find((item) => item?.uniqueid === edit) || {};
      console.log(oneaccount, "oneaccount");
      seteditTrue(0);
      seteditdataHandler(oneaccount);
    }

    // console.log(state.popUpState,"popUpupState")

    if (state.popUpState) {
      // console.log(state.popUpState.popstatus.status==201,"popUpStatestatus")
      if (state.popUpState.popstatus.status == 201 && closer) {
        setCloser(false);
        handleClose();
        dispatch(TierListReducerAction(CAPEXReport));
        popUpUpdate({});
      }
    }

    let tier = state.CommonResponse.listtier;

    let account = state.CommonResponse.accounts;
    let index = 0;
    if (tier && tier.length != 0) {
      tierArry = tier.map((item) => {
        console.log(item, "itemitemitemitemitemitem");
        index = index + 1;
        return {
          sNo: index,
          // site_id: item.site_id,
          inc_ticket: item.inc_ticket,
          status: item.status,
          site_id: item.site_id,
          xPEX: item.xPEX,
          gc: item.gc,
          // tech_affected: item.tech_affected,
          tech_affected: item?.tech_affected || " ",
          // sector: item.sector,
          sector: item?.sector || " ",
          category: item.category,
          mcps_engineer: item.mcps_engineer,
          work_log_display: (
            <p
              className={"text-black my-0 modalHoverClass"}
              onClick={() =>
                CommonModalFun(
                  <p
                    style={{
                      border: "2px solid black",
                      color: "black",
                      padding: 2,
                    }}
                    className="CommonModal"
                  >
                    {item.work_log}
                  </p>,
                  "Comment",
                  "Work log"
                )
              }
            >
              {wrapText(item.work_log)}
            </p>
          ),
          work_log_print: item.work_log,
          Case: item?.Case || " ",
          inc_assigned: item.inc_assigned,
          assigned_group: item.assigned_group,
          date: item.date,
          reassigned_date: item.reassigned_date,
          pier: item.pier,
          resolution: item.resolution,
          market_name: item.market_name,
          account_name: item.account_name,
          assignee: item.assignee,
          aging: item.aging,
          issue_owner: item.issue_owner,
          go_back_date: item.go_back_date,
          updatednotes: Array.isArray(item?.notes)
            ? item?.notes
                ?.map(
                  (item) =>
                    `${item?.created_date} - ${item?.name} - ${item?.text}`
                )
                .join("\n")
            : "",

          notes: Array.isArray(item?.notes) ? (
            <div style={{ whiteSpace: "pre-line" }}>
              <p
                className={"text-black my-0 modalHoverClass"}
                onClick={() =>
                  CommonModalFun(
                    <p
                      style={{
                        border: "2px solid black",
                        color: "black",
                        padding: 2,
                      }}
                      className="CommonModal"
                    >
                      {item?.notes?.map((note, index) => (
                        <p
                          key={index}
                        >{`${note?.created_date} - ${note?.name} - ${note?.text}`}</p>
                      ))}
                    </p>,
                    "Comment",
                    "NOTES"
                  )
                }
              >
                {wrapText(
                  item?.notes
                    ?.map(
                      (note, index) =>
                        `${note?.created_date} - ${note?.name} - ${note?.text}`
                    )
                    .join("\n")
                )}
              </p>
            </div>
          ) : (
            <p></p>
          ),

          // notes: Array.isArray(item?.notes) ? item?.notes?.map(item => {
          //     return <>{`${item?.created_date} - ${item?.name} - ${item?.text}`}</>
          // }) : '',
          action: (
            <div className="d-flex">
              <Link
                href="#"
                onClick={() => {
                  editpopupHandler(item);
                  reset({});
                  addformtype("Edit");
                  handleShow();
                }}
                className="btn btn-primary shadow btn-xs sharp mr-1"
              >
                <i className="fa fa-pencil"></i>
              </Link>
              {/* <Link
                            href="#"
                            onClick={(e) => deleteHandler(item.uniqueid)}
                            className="btn btn-danger shadow btn-xs sharp"
                        > 
                            <i className="fa fa-trash"></i>
                        </Link> */}
            </div>
          ),
          // <button value={item.uniqueid} onClick={(e)=>updateHandler(e)}>Click me</button>
        };
      });
    }

    if (account != 0) {
      accountArry = account.map((item) => {
        return <option value={item.uniqueid}>{item.accountName}</option>;
      });
    }

    let userroledata = state.CommonResponse.userrole;
    console.log(state, "state.CommonResponse");
    console.log(userroledata, "projectStatus");
    if (userroledata != 0) {
      pStatusArry = userroledata.map((item) => {
        return <option value={item.uniqueid}>{item.rolename}</option>;
      });
    }

    let markarr = [];
    let marketroledata = state.CommonResponse.markets;
    if (marketroledata != 0) {
      mStatusArry = marketroledata.map((item) => {
        return {
          value: item.marketName,
          label: item.marketName,
        };
      });
    }
    let crewroledata = state.CommonResponse.crewCompany;
    if (crewroledata != 0) {
      cStatusArry = crewroledata.map((item) => {
        return <option value={item.uniqueid}>{item.crewCompanyName}</option>;
      });
    }

    let vendorroledata = state.CommonResponse.vendor;
    if (vendorroledata != 0) {
      vStatusArry = vendorroledata.map((item) => {
        console.log(ven, item.uniqueid, "ven==item.uniqueid");
        return <option value={item.uniqueid}>{item.vendorName}</option>;
        // if(ven==item.uniqueid){
        //   return <option selected value={item.uniqueid}>{item.vendorName}</option>
        // }else{
        //   return <option value={item.uniqueid}>{item.vendorName}</option>
        // }
      });
    }

    console.log(pStatusArry, "pStatusArry");

    return {
      tierArry,
      accountArry,
      pStatusArry,
      mStatusArry,
      oneaccount,
      cStatusArry,
      vStatusArry,
    };
  });

  console.log(data, "data");
  const noOfRow = data.accountArry.length;
  // data.accountArry.push(
  //   {
  //       sNo:noOfRow+1,
  //       account:<input type='text' placeholder='Add Account' value={newAccount} onChange={(e)=>setAccount(e.target.value)}/>,
  //       edit : <button onClick={()=>addAccount()}>Add Account</button>

  //   }
  // )

  useEffect(() => {
    dispatch(RoleReducerAction(listRole_twoApi));
    dispatch(AccountReducerAction(accountApi));
    dispatch(TierListReducerAction(CAPEXReport));

    dispatch(UserListReducerAction(listUserApi_two));
    dispatch(GetMarketReducerAction(getMarket));
    dispatch(AccountReducerAction(crewCompanyApi));
    dispatch(AccountReducerAction(vendorApi));
    dispatch(AccountReducerAction("/manage_engineer_name"));
    dispatch(AccountReducerAction("/manage_account_name"));
    dispatch(AccountReducerAction("/manage_market_name"));
    dispatch(AccountReducerAction("/manage_technology_name"));
    // dispatch(AccountReducerAction('/manage_gc_name'));
    dispatch(AccountReducerAction("/manage_gc_company"));
    dispatch(AccountReducerAction("/manage_site_id"));

    // dispatch(AccountReducerAction(viewmpimpo))
  }, [newAccount]);
  const columns = [
    // {

    //   name: "sNo",
    //   label: "S. No.",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     searchable:false,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    // {
    //   name: "lookup_value",
    //   label: "Name",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    {
      name: "inc_ticket",
      label: "INC TICKET #",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    {
      name: "status",
      label: "STATUS",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "date",
      label: "DATE CREATED",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "aging",
      label: "AGING",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "issue_owner",
      label: "ISSUE OWNER",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    // {
    //   name: "market_name",
    //   label: "MARKET NAME",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    {
      name: "site_id",
      label: "SITE ID",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    {
      name: "xPEX",
      label: "TYPE",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "gc",
      label: "GC",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "tech_affected",
      label: "TECH AFFECTED",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    {
      name: "sector",
      label: "SECTOR",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    {
      name: "category",
      label: "CATEGORY",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
            minWidth: "150px",
          },
        }),
      },
    },

    // {
    //   name: "bridge_support",
    //   label: "Bridge Support",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    // {
    //   name: "mcps_engineer",
    //   label: "MCPS ENGINEER",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },

    // {
    //   name: "Case",
    //   label: "CASE",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    // {
    //   name: "inc_assigned",
    //   label: "INC ASSIGNED",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    {
      name: "assigned_group",
      label: "SR ASSIGNED GROUP",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "assignee",
      label: "ASSIGNEE",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
            minWidth: "150px",
          },
        }),
      },
    },

    {
      name: "work_log_display",
      label: "WORK LOG",
      options: {
        filter: true,
        print: false,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "work_log_print",
      label: "WORK LOG",
      options: {
        filter: true,
        display: false,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
            minWidth: "150px",
          },
        }),
      },
    },
    {
      name: "go_back_date",
      label: "GO BACK DATE",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
    {
      name: "notes",
      label: "NOTES",
      options: {
        filter: true,
        print: false,
        setCellProps: () => ({
          style: {
            "min-width": "200px",
            "text-align": "left",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    {
      name: "updatednotes",
      label: "NOTES",
      options: {
        display: false,
        filter: true,
        setCellProps: () => ({
          style: {
            "min-width": "200px",
            "text-align": "left",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },

    // {
    //   name: "reassigned_date",
    //   label: "DATE REASSIGNED",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    // {
    //   name: "pier",
    //   label: "PIER STATUS",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    // {
    //   name: "resolution",
    //   label: "RESOLUTION",
    //   options: {
    //     filter: true,
    //     setCellHeaderProps: () => ({
    //       style: {

    //         alignItem: "center",
    //         background: "#143b64",
    //         color: "white"

    //       }
    //     })
    //   }
    // },
    {
      name: "action",
      label: "ACTION",
      options: {
        filter: false,
        sort: false,
        print: false,
        searchable: false,
        setCellHeaderProps: () => ({
          style: {
            alignItem: "center",
            background: "#143b64",
            color: "white",
          },
        }),
      },
    },
  ];
  let row = [];

  const handleChange = (e) => {
    console.log("the current anser= ", e.target.value);
  };

  const AddCustomButton = () => (
    <fregment
      style={{
        float: "right",
        display: "flex",
        flexDirection: row,
        justifyContent: "space-between",
      }}
    >
      {/* <div> */}
      {/* <Button className="btn btn-primary btn-xs mx-2 py-2 my-3" onClick={() => { handleShow(); reset({}); addformtype("Add") }}>Add Manage Engineer</Button> */}
      {/* <Button className="btn-xs mt-3 mr-2 mb-2 float-right" onClick={() => { filehandleShow(); reset({}); addformtype("Upload ") }}>Upload File</Button> */}
      {/* </div> */}

      {/* <CommonBulkUploader typeForm={"CAPEXReport"} afterLoad={CsvUpload} shortCode={"Rtwp"} classes={'btn btn-primary btn-xs mx-2 py-2 my-3'} /> */}
      <Modal show={show} size="lg">
        <Modal.Header>
          <Modal.Title>{formtype} CAPEX REPORT </Modal.Title>
          <Button onClick={() => setShow(false)} variant="" className="close">
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="card " style={{ width: "100%" }}>
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div className="accordion-item">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <div className="accordion-body">
                      <div className="form-row mt-2 p-2">
                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            INC TICKET<span style={{ color: "red" }}>*</span>{" "}
                          </label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            required
                            id="inputEmail4"
                            name="inc_ticket"
                            {...register("inc_ticket")}
                          />
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            STATUS<span style={{ color: "red" }}>*</span>{" "}
                          </label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            name="status"
                            required
                            disabled
                            className="custom-select-style form-control"
                            {...register("status", {
                              onChange: (e) => {
                                setalersdadsa(e.target.value);
                              },
                            })}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="Close">Close</option>
                            <option value="Open">Open</option>
                          </select>
                        </div>
                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            DATE CREATED<span style={{ color: "red" }}>*</span>
                          </label>
                          <div
                            style={{ height: "40px" }}
                            type="text"
                            min={0}
                            max={100}
                            // className="form-control"
                            required
                            id="inputEmail4"
                            name="date"
                          >
                            <DatePicker
                              {...register("date")}
                              placeholderText="DD/MM/YYYY hh:mm"
                              id="color-of-datepicker"
                              className="date-picker-changes "
                              popperPlacement="left"
                              selected={date}
                              autoComplete={"off"}
                              showTimeSelect
                              readOnly
                              timeIntervals={1}
                              timeCaption="Time"
                              onChange={(e) => {
                                dfefdewdewdate(e);
                                // setfenddate(e);
                              }}
                              dateFormat="dd/MM/yyyy hh:mm:ss"
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            ISSUE OWNER<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("issue_owner")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="GC">GC</option>
                            <option value="RF">RF</option>
                            <option value="UMLAUT">UMLAUT</option>
                            <option value="TOWER TEAM">TOWER TEAM</option>
                            <option value="FYI - SR ONLY">FYI - SR ONLY</option>
                          </select>
                        </div>

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">ACCOUNT NAME<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            required
                            type="text"
                            className="custom-select-style form-control"
                            {...register("account_name")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>

                            {
                              accountss?.map(item => {
                                return <option value={item?.accountName}>{item?.accountName}</option>
                              })
                            }
                          </select>
                        </div> */}

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">MARKET NAME<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            required
                            type="text"
                            className="custom-select-style form-control"
                            {...register("market_name")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {
                              marketnames?.map(item => {
                                return <option value={item?.marketName}>{item?.marketName}</option>
                              })
                            }
                          </select>
                        </div> */}

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">Site ID<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            required
                            type="text"
                            className="custom-select-style form-control"
                            {...register("site_id")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {
                              siteid?.map(item => {
                                return <option value={item?.site_id}>{item?.site_id}</option>
                              })
                            }
                          </select>
                        </div> */}

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">SITE ID</label>
                          <input
                            style={{ height: "40px" }}
                            type="text"
                            className="form-control"
                            readOnly
                            id="input "
                            autoComplete={false}
                            list="cars"
                            placeholder="enter Site Id"
                            {...register("site_id")}
                          />
                          <datalist id="cars">{optionsss.site_idss}</datalist>
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            xPEX<span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            disabled
                            {...register("xPEX")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="CAPEX">CAPEX</option>
                            <option value="OPEX">OPEX</option>
                          </select>
                        </div>

                        {/*                 
                <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">GC<span style={{ color: "red" }}>*</span></label>

                    <select
                        style={{ height: "32px" }}
                        type="text"
                        className="custom-select-style form-control"
                        required
                        {...register("gc")}
                    >
                        <option selected disabled value="">
                            Select...
                        </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div> */}

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            GC<span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            style={{ height: "32px" }}
                            required
                            type="text"
                            disabled
                            className="custom-select-style form-control"
                            {...register("gc")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {gc?.map((item) => {
                              return (
                                <option value={item?.company_name}>
                                  {item?.company_name}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">TECH AFFECTED<span style={{ color: "red" }}>*</span></label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("tech_affected")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {
                              techname?.map(item => {
                                return <option value={item?.technologyName}>{item?.technologyName}</option>
                              })
                            }
                          </select>
                        </div> */}

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            TECH AFFECTED<span style={{ color: "red" }}>*</span>
                          </label>

                          <MultiSelect
                            className="light"
                            required
                            onChange={setTech}
                            disabled
                            value={tech_affected}
                            options={optionss.multipleTechno}
                          />
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            SECTOR<span style={{ color: "red" }}>*</span>
                          </label>
                          <MultiSelect
                            className="light"
                            required
                            disabled
                            onChange={handlesetSectorImpect}
                            value={sImpact}
                            options={newmStatusArry}
                          />
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">
                            CATEGORY<span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            disabled
                            {...register("category")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="PIM - Internal">
                              PIM - Internal
                            </option>
                            <option value="PIM - External">
                              PIM - External
                            </option>
                            <option value="External Interference">
                              External Interference
                            </option>
                            <option value="PIM Internal / External Interference">
                              PIM Internal / External Interference
                            </option>
                            <option value="PIM Internal / PIM External">
                              PIM Internal / PIM External
                            </option>
                            <option value="No Issues">No Issues</option>
                            <option value="PIM - External / External Interference">
                              PIM - External / External Interference
                            </option>
                          </select>
                        </div>

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">MCPS ENGINEER</label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            {...register("mcps_engineer")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {
                              engineers?.map(item => {
                                return <option value={item?.name}>{item?.name}</option>
                              })
                            }
                          </select>
                       
                        </div> */}

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            WORK LOG
                          </label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            readOnly
                            className="form-control"
                            id="inputEmail4"
                            name="work_log"
                            {...register("work_log")}
                          />
                        </div>

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">CASE<span style={{ color: "red" }}>*</span>
                          </label>
                          <MultiSelect
                            className="light"
                            required
                            onChange={handleCase}
                            value={Case}
                            options={caseStatusarry}
                          />
                        </div> */}

                        {/* 
                        <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">INC ASSIGNED TO<span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("inc_assigned")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="PAG">PAG</option>
                            <option value="UMLAUT">UMLAUT</option>
                            <option value="FOPS">FOPS</option>
                            <option value="TMO-RF">TMO-RF</option>
                          </select>
                        </div> */}

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            INC ASSIGNED GROUP
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            required
                            placeholderText="ASSIGNED GROUP"
                            readOnly
                            id="inputEmail4"
                            name="assigned_group"
                            {...register("assigned_group")}
                          />
                        </div>

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            ASSIGNEE
                          </label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            readOnly
                            id="inputEmail4"
                            name="assignee"
                            {...register("assignee")}
                          />
                        </div>

                        {/* <div className="form-group col-md-3">
                                                    <label htmlFor="subtractedDays"> AGING</label>
                                                    <div style={{ height: "40px" }}>
                                                        <input
                                                            {...register("aging")}
                                                            type="text"
                                                            value={subtractedDays}
                                                            readOnly
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                setSubtractedDays(e);

                                                            }}
                                                        />
                                                    </div>
                                                </div> */}

                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            GO BACK DATE
                          </label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            id="inputEmail4"
                            name="go_back_date"
                            {...register("go_back_date")}
                          />
                        </div>

                        {/* <div className="form-group col-md-3">
                                                    <label for="exampleFormControlSelect1">NOTES<span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        style={{ height: "32px" }}
                                                        type="text"
                                                        min={0}
                                                        max={100}
                                                        className="form-control"

                                                        placeholderText='Notes'
                                                        id="inputEmail4"
                                                        name="notes"
                                                        {...register("notes")}
                                                    />
                                                
                                                </div> */}

                        <div className="form-group col-md-5">
                          <label htmlFor="exampleFormControlSelect1">
                            NOTES<span style={{ color: "red" }}>*</span>
                          </label>
                          <div style={{ display: "flex" }}>
                            <textarea
                              style={{ height: "32px", marginRight: "10px" }}
                              //   type="text"
                              min={0}
                              max={100}
                              className="form-control"
                              placeholder="Notes"
                              disabled
                              id="inputEmail4"
                              name="notes"
                              {...register("notes")}
                            />
                            <span
                              //   className="btn btn-primary"
                              onClick={handleAddClick}
                            >
                              <p
                                className={`badge   badge-primary  my-0  `}
                                style={{ width: "50px", marginTop: "5px" }}
                              >
                                <Add />
                              </p>
                            </span>
                          </div>
                          {showPopup && (
                            <div className="popup">
                              <div className="popup-inner">
                                <textarea
                                  style={{
                                    height: "32px",
                                    marginRight: "20px",
                                  }}
                                  //   type="text"
                                  min={0}
                                  cols="6"
                                  rows="1"
                                  className="form-control"
                                  placeholder="Notes"
                                  value={noteValue}
                                  onChange={handleNoteChange}
                                />
                                <button
                                  className="btn btn-primary"
                                  onClick={handleAddNote}
                                >
                                  Add Note
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={handlePopupClose}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* 
                        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            DATE REASSIGNED
                          </label>
                          <div
                            style={{ height: "40px" }}
                            type="text"
                            min={0}
                            max={100}
                            // className="form-control"
                            placeholderText='DATE REASSIGNED'
                            required
                            id="inputEmail4"
                            name="reassigned_date"
                          >


                            {console.log("reassigned_date", reassigned_date)}
                            <DatePicker
                              {...register("reassigned_date")}
                              placeholderText="DD/MM/YYYY hh:mm"
                              id="color-of-datepicker"
                              className="date-picker-changes"
                              popperPlacement="left"
                              selected={reassigned_date}
                              autoComplete={"off"}

                              dateFormat="dd/MM/yyyy hh:mm:ss"
                              showTimeSelect
                              timeIntervals={1}
                              timeCaption="Time"
                              onChange={(e) => {
                                dfedate(e);
                                // setfenddate(e);
                              }}
                            />
                          </div>
                        </div> */}

                        {/* <div className="form-group col-md-3">
                          <label htmlFor="inputEmail4">PIER STATUS<span style={{ color: "red" }}>*</span></label>
                          <select
                            style={{ height: "32px" }}
                            type="text"
                            className="custom-select-style form-control"
                            required
                            {...register("pier")}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            <option value="Closed">Closed</option>
                            <option value="Assigned">Assigned</option>
                            <option value="Waiting">Waiting</option>
                            <option value="Resolved">Resolved</option>
                          </select>
                        </div> */}

                        {/* <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">RESOLUTION<span style={{ color: "red" }}>*</span></label>
                          <input
                            style={{ height: "32px" }}
                            type="text"
                            min={0}
                            max={100}
                            className="form-control"
                            required={alersdadsa == "Close" ? true : false}
                            placeholderText='RESOLUTION'
                            id="inputEmail4"
                            name="resolution"
                            {...register("resolution")}
                          />
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary col-xs">
                    {" "}
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <CommonModal
        modalSize={"xm"}
        setXlShow={setcommonModalStateFilter}
        xlShow={commonModalStateFilter}
        Body={myRef.current}
        Header={"Comments"}
        Title={commonModalTitleFilter}
      ></CommonModal>

      {/* <Modal show={show} onHide={filehandleClose} size="sm">
                <Modal.Header closeButton>
                    <Modal.Title >{formtype} Crew</Modal.Title>
                </Modal.Header>

                <form onSubmit={(e) => submitHandler(e)} encType="multipart/form-data" className="mx-2">
                    <div className="input-group mb-3 fileSection">

                        <div>
                            <label class="custom-file-upload btn btn-outline-primary col-md-12">
                                <input
                                    type="file"
                                    className="form-control btn btn-primary"
                                    id="inputGroupFile04"
                                    aria-describedby="inputGroupFileAddon04"
                                    aria-label="Upload"
                                    name="file"
                                    multiple
                                    onChange={uploadCsvFile}
                                />
                                <i class="fa fa-cloud-upload"></i> Choose File
                            </label>

                        </div>

                     
                        <button
                            className=" btn-primary"
                            type="submit"
                            id="inputGroupFileAddon04"
                        >
                            Submit
                        </button>
                    </div>

                </form> */}
      {/* <div className="form-row mt-2 p-2">
            <div>
              Crew File :
              <label class="custom-file-upload btn btn-outline-primary btn-xs col-md-12">
                <input style={{ height: "32px" }}
                  type="file"
                  className="form-control btn btn-primary"
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  name="file"
                  onChange={uploadCsvFile}

                />
                <i class="fa fa-cloud-upload"></i> Choose Crew File
              </label>
            </div>
          </div> */}

      {/* </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary btn-xs" onClick={filehandleClose}>
            Close
          </Button>
          <Button variant="primary btn-xs" onClick={submitHandler}>
            Upload File
          </Button>
        </Modal.Footer> */}
      {/* </Modal> */}
    </fregment>
  );

  //    const data = [
  //     { name: "Joe James", company: "In Progress", city: "Yonkers", state: "NY" },
  //     { name: "John Walsh", company: "Completed", city: "Hartford", state: "CT" },
  //     { name: "Bob Herm", company: "Awaited", city: "Tampa", state: "FL" },
  //     { name: "James Houston", company: "NA", city: "Dallas", state: "TX" },
  //    ];

  return (
    <>
      <CommonModal
        modalSize={commonModalSize}
        setXlShow={setcommonModalState}
        xlShow={commonModalState}
        Body={commonModalBody}
        Header={commonModalHeader}
        Title={commonModalTitle}
      ></CommonModal>

      <ThemeProvider theme={getMuiThemeCommon()}>
        <MUIDataTable
          title={"CAPEX REPORT"}
          data={data.tierArry}
          columns={columns}
          // options={customDataTableOptionObject(AddCustomButton,false,"")}
          options={advancdExportOnecustomDataTableOptionObject(
            AddCustomButton,
            true,
            "CAPEXReport_",
            "",
            false,
            "CAPEXReport"
          )}
        />
      </ThemeProvider>
    </>
  );
};

export default CapexReport;
